export default __webpack_public_path__ + "static/media/cover_page-02_720.0333cf36.png";